const messages = {
  title: "Bonusmultiplikator",
  bandBonusTitle: "Bonus per däck med multiplikator",
  amountLabel: "Min. antal däck (*)",
  label: "Bonusmultiplikator",
  desc: "Antal Bridgestone- och Firestone-däck. Det finns ingen bonus i euro på Firestone-däck.",
  goals: {
    loyal: "Lojal",
    bronze: "Brons",
    silver: "Silver",
    gold: "Guld",
    platinum: "Platina",
  },
  andMore: "och mer",
  chooseTarget: "Välj",
  selectTarget: "Välj ditt årliga mål för {year} här:",
  multiplication: "Bonus multipliceras med <b>{factor}</b>",
  minTyres: "<b>Minst:</b> {tyre} däck",
};

export default {
  messages,
};
